import { TABLE_NO_DATA_CELL } from '../constants/data';

const PERCENTAGE_STR = '%';

const NUMBER_FORMAT = { maximumFractionDigits: 2 };

export const renderRate = (rate: number | undefined) => {
  if (rate == null) return TABLE_NO_DATA_CELL;

  const rateString = rate.toLocaleString(undefined, NUMBER_FORMAT);

  return `${rateString}${PERCENTAGE_STR}`;
};
